import { useTranslation } from 'react-i18next';
import { MarketCheckmarkCircleIcon } from '@squareup/market-react/icons';
import { formatCurrency, type MoneyUnion } from '../../../../utils/format-currency';
import styles from './FolderProgressBar.module.css';

interface FolderProgressBarProps {
  balance: MoneyUnion;
  target: MoneyUnion;
}

export const FolderProgressBar = ({ balance, target }: FolderProgressBarProps) => {
  const { t, i18n } = useTranslation();
  const balanceAmount: number = balance.amount || 0;
  const targetAmount: number = target.amount || 0;
  const locale = i18n.language || 'en-US';

  const max: number = targetAmount > 0 ? targetAmount : 1;
  const value: number = balanceAmount > 0 ? Math.min(balanceAmount, targetAmount) : 0;
  const percentComplete: number = (value / max) * 100;
  const formattedAmount = formatCurrency({ currencyValue: target, locale });

  if (balanceAmount >= targetAmount) {
    return (
      <div className={`${styles.targetReached} paragraph-30`} data-testid="folder-target-reached">
        <MarketCheckmarkCircleIcon />
        {t('bankingShared.header.targetReached', { amount: formattedAmount })}
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <progress
        value={value}
        max={max}
        className={styles.progress}
        style={{ ['--percent' as string]: `${percentComplete}%` }}
      />
      <div className={`${styles.target} paragraph-30`}>{t('bankingShared.header.target', { amount: formattedAmount }) }</div>
    </div>
  );
};
